








import {Component, Prop, Vue} from "vue-property-decorator";
import {AxiosError, AxiosResponse} from "axios";
import {mapGetters} from "vuex";
import {User} from "@/types";

@Component({
    components: {},
    computed: {...mapGetters(["user"])},
})
export default class SubscribeBtn extends Vue {
    @Prop() community!: any;
    private user!: User;


    subscribe() {
        if (this.user) {
            this.$api.subscribe({user_id: this.user.id, community_id: this.community.id})
                .then((res: AxiosResponse) => {
                    this.$emit('reFetch')
                }).catch((err: AxiosError) => {
                if (err.message) {
                    alert(err.message)
                }
            })
        }
        else {
            this.$store.commit('needLogin', true)
            this.$modal.show('needLogin')
        }
    }

    unsubscribe() {
        this.$emit('unsubscribe', this.community.id)

    }
}
